<div *ngIf="text" [matTooltip]="tooltip">
  {{ text | slice: 0:limitContentLength }}
  <span *ngIf="limitContentLength < text.length">...</span>
</div>
